// extracted by css-extract-rspack-plugin
export default {"body":"index__body___adY6G","title":"index__title___wriGr"};